export const formatDayPart = (part: string | undefined | null): string => {
  switch (part) {
    case "first_half":
      return "First Half";
    case "second_half":
      return "Second Half";
    case "full":
      return "Full Day";
    default:
      return part || "--";
  }
};

export const capitalize = (text: string | undefined | null): string => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};
